import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { OVERLAY_DEFAULT_CONFIG } from '@angular/cdk/overlay';
import { routes } from './app.routes';
import { HttpClient, provideHttpClient, withInterceptors } from '@angular/common/http';
import { initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { provideAuth, getAuth } from '@angular/fire/auth';
import { provideFirestore, getFirestore } from '@angular/fire/firestore';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateUniversalLoader } from './translate-universal-loader';
import { provideMatomo, withRouteData, withRouter } from 'ngx-matomo-client';
import { provideAnimations } from '@angular/platform-browser/animations';
import { tokenInterceptorFn } from './core/http/token.interceptor';

import { SmService } from 'supermappe-core';

import { environment } from '../../../commondata/environments/environment';
import { MAT_DATE_LOCALE } from '@angular/material/core';

export const appConfig: ApplicationConfig = {
  providers: [
    SmService,
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideAnimations(),
    provideHttpClient(withInterceptors([tokenInterceptorFn])),
    provideFirebaseApp(() => initializeApp(environment.configFirebase)),
    provideFirestore(() => getFirestore()),
    provideAuth(() => getAuth()),
    { provide: OVERLAY_DEFAULT_CONFIG, useValue: { usePopover: false } },

    [{ provide: MAT_DATE_LOCALE, useValue: 'it-IT' }],
    provideMatomo(
      { trackerUrl: 'https://matomo.anastasis.it/', siteId: environment.production ? '4' : '7' },
      withRouter(),
      withRouteData(),
    ),
    importProvidersFrom([
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useClass: TranslateUniversalLoader,
          deps: [HttpClient],
        },
      }),
    ]),
  ],
};
